import { createSlice } from '@reduxjs/toolkit'
import {getEmailRecipients, getTemplates, getTemplatesPag, getTemplateTypes} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= {
    templates: {
    },
    templatesPag: {
      pageIndex: 0,
      totalRecords: 10,
      totalPages: 1,
      pageSize: 10,
      hasPreviousPage: false,
      hasNextPage: false,
      elements: []
    },
    templateTypes: [],
    emailRecipients: [],
    loading: "idle",
    loadingTypes: "idle",
    loadingRecipients: "idle",
    error: null }

  const templatesSlice = createSlice({
    name: 'templates',
    initialState,
    reducers: {
      clearTemplatesError: (state)=>{
        state.error = null
        state.loading = "idle"
      }
    },
    extraReducers: {
      [getTemplates.pending]: (state) => {
          state.loading = "loading";
          state.error = null
        },
      [getTemplates.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.templates = action.payload
      },
      [getTemplates.rejected]: (state, action) => {
          state.loading = "failed";
          state.error = action.error.message
        },
      [getTemplatesPag.pending]: (state)=>{
        state.loading = "loading";
        state.error = null
      },
      [getTemplatesPag.fulfilled]: (state, action)=>{
        state.loading = "succeeded";
        state.templatesPag.elements = action.payload.elements
        state.templatesPag.pageIndex = action.payload.pageIndex;
        state.templatesPag.totalRecords = action.payload.totalRecords;
        state.templatesPag.totalPages = action.payload.totalPages;
        state.templatesPag.pageSize = action.payload.pageSize;
        state.templatesPag.hasPreviousPage = action.payload.hasPreviousPage;
        state.templatesPag.hasNextPage = action.payload.hasNextPage
      },
      [getTemplatesPag.rejected]: (state, action)=>{
        state.loading = "failed";
        state.error = action.error.message
      },
      [getTemplateTypes.pending]: (state) =>{
        state.loadingTypes = "loading"
      },
      [getTemplateTypes.fulfilled]: (state, action)=>{
        state.loadingTypes = "succeeded"
        state.templateTypes = action.payload
      },
      [getTemplateTypes.rejected]: (state, action) =>{
        state.loadingTypes = "failed";
        state.error = action.error.message
      },
      [getEmailRecipients.pending]: (state) => {
        state.loadingRecipients = "loading"
      },
      [getEmailRecipients.fulfilled]: (state, action)=>
        {
          state.loadingRecipients = "succeeded";
          state.emailRecipients = action.payload;
      },
      [getEmailRecipients.rejected] : (state, action)=>{
        state.loadingRecipients = "failed";
        state.error = action.error.message
      },
      [logOut]: (state)=> initialState
    }
  })

  export const {clearTemplatesError} = templatesSlice.actions;
  export default templatesSlice.reducer